export const generateNameFromAlias = (alias?: string): string => {
  if (!alias) {
    return '';
  }

  return alias
    .split('_')
    .map((word, index, words) => {
      if (index === words.length - 1 && (word === 'ftd' || word === 'ttd')) {
        return word.toUpperCase();
      }

      if (index === 0) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }

      return word;
    })
    .join(' ');
};
